import { getUserLocation, getCountries } from "@/helpers";

type Country = {
  twoAlphaCode: string;
  swdcRegion: string;
};

export async function getRegionForCountry(
  userLocation: NonNullable<Awaited<ReturnType<typeof getUserLocation>>>,
): Promise<string | undefined> {
  const countries = (await getCountries())?.countryLocations;

  if (!countries) {
    return;
  }

  const country = countries.find(
    (c: Country) => c.twoAlphaCode === userLocation.isoCountryCode,
  );

  if (!country) {
    return;
  }

  return country.swdcRegion;
}
